// extracted by mini-css-extract-plugin
export default {"pagecontainer":"Addproducts_pagecontainer__BfhR9","form":"Addproducts_form__M9oxl","formrow":"Addproducts_formrow__cnPSt","button":"Addproducts_button__+y5OU"};